import React from "react";
import webui, { BaseComponent } from "@tinqin/tinqin-web-ui";

//simple list <ul>(default) or <ol> with <li> children
class SimpleList extends BaseComponent {
    render() {
        if (this.props.config.bindTo) {
            const data = this.props.data ? this.props.data.properties || {} : null;
            if (!data) {
                return this.getEmptyContent();
            }
        }

        const dataProps = webui.getUtils().extractComponentProps(this.props, {
            additionalProps: ["tag", "extraClasses"],
            propsDefaults: {
                tag: "ul",
                extraClasses: ""
            }
        });
        return React.createElement(
            dataProps.tag,
            { className: dataProps.extraClasses },
            this.resolveChildren().map((item, index) => <li key={index}>{item}</li>)
        );
    }
}

export default webui.connectComponent()(SimpleList);
